<div class="container-fluid">
    <div class="appointment-toolbar mb-3">
        <div>
            <div class="row g-2 align-items-center">
                <div class="col-sm-auto">
                    <button class="btn btn-primary btn-sm week-nav-btn" (click)="goToPrevious()">
                <span class="svg-icon svg-icon-primary svg-icon-2x">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <polygon points="0 0 24 0 24 24 0 24" />
                            <path
                                d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                                fill="#ffffff" fill-rule="nonzero"
                                transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) " />
                            <path
                                d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                                fill="#ffffff" fill-rule="nonzero" opacity="0.3"
                                transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) " />
                        </g>
                    </svg>
                </span>
                    </button>
                </div>
                <div class="col-sm-3">
                    <h4 class="mb-0">{{name | titlecase}}</h4>
                    <small class="text-muted">{{ weekRangeLabel }}</small>
                </div>
                <div class="col-sm-6 ms-auto">
                    <div class="input-group">
                        <input class="form-control" type="text" placeholder="Search by patient number, name, or phone..."
                            [(ngModel)]="textName" (input)="onSearchChange()">
                        <button *ngIf="textName" type="button" class="btn btn-outline-secondary" (click)="clearSearch()">Clear</button>
                        <button type="button" class="btn btn-success" (click)="open(contentAppointment, 'contentAppointment')">
                    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px"
                        viewBox="0 0 24 24" width="24px" fill="#ffffff">
                        <g>
                            <rect fill="none" height="24" width="24" />
                            <rect fill="none" height="24" width="24" />
                        </g>
                        <g>
                            <g>
                                <polygon points="22,9 22,7 20,7 20,9 18,9 18,11 20,11 20,13 22,13 22,11 24,11 24,9" />
                                <path d="M8,12c2.21,0,4-1.79,4-4s-1.79-4-4-4S4,5.79,4,8S5.79,12,8,12z" />
                                <path d="M8,13c-2.67,0-8,1.34-8,4v3h16v-3C16,14.34,10.67,13,8,13z" />
                                <path
                                    d="M12.51,4.05C13.43,5.11,14,6.49,14,8s-0.57,2.89-1.49,3.95C14.47,11.7,16,10.04,16,8S14.47,4.3,12.51,4.05z" />
                                <path
                                    d="M16.53,13.83C17.42,14.66,18,15.7,18,17v3h2v-3C20,15.55,18.41,14.49,16.53,13.83z" />
                            </g>
                        </g>
                    </svg>
                    New Appointment
                        </button>
                    </div>
                </div>
                <div class="col-sm-auto text-end">
                    <button class="btn btn-primary btn-sm week-nav-btn" (click)="goToNext()">
                <span class="svg-icon svg-icon-primary svg-icon-2x">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                        height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <polygon points="0 0 24 0 24 24 0 24" />
                            <path
                                d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                                fill="#ffffff" fill-rule="nonzero" />
                            <path
                                d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                                fill="#ffffff" fill-rule="nonzero" opacity="0.3"
                                transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) " />
                        </g>
                    </svg>
                </span>
                    </button>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-sm-12 d-flex gap-2 flex-wrap">
                    <span class="badge text-bg-light">Total {{ appointments.length }}</span>
                    <span class="badge text-bg-success">Completed {{ getStatusCount('COMPLETED') }}</span>
                    <span class="badge text-bg-warning">Pending {{ getStatusCount('PENDING') }}</span>
                    <span class="badge text-bg-danger">Cancelled/Missed {{ getStatusCount('CANCELLED') + getStatusCount('MISSED') }}</span>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-sm-12">
            <div class="table-responsive schedule-table-wrap">
                <table class="table table-bordered schedule-table" id="excel-table">
                    <thead>
                        <tr class="table-secondary">
                            <th class="time-col">#</th>
                            <th *ngFor="let date of dateList">{{ date | date: 'EEEE'}} <sup>{{date | date : 'MMM d'}}</sup>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let time of timeList; let i = index;">
                            <ng-container *ngIf="time != '24:00'">
                                <td class="time-col">{{ time | timeFormat }} - {{ timeList[i+1] | timeFormat }}</td>
                                <td *ngFor="let date of dateList">
                                    <div *ngFor="let appointment of checkItem(date, time, timeList[i+1])"
                                        class="appointment-entry"
                                        [class.appointment-match]="appointmentMatchesSearch(appointment)">
                                        <span class="badge bg-secondary mx-1 appointment-click"
                                            (click)="goToDetails(appointment)">
                                            {{ appointment?.patient.first_name }} {{ appointment?.patient.last_name }}
                                        </span>
                                        <span class="badge bg-primary mx-1">{{ appointment?.appointment.service_name }}</span>
                                        <span class="badge bg-warning mx-1">{{ get_room(appointment?.appointment.room) }}</span>
                                        <span class="badge bg-success mx-1">{{ appointment?.doctor.name | slice:0:1}}</span>
                                        <span class="badge bg-danger mx-1">{{ appointment?.appointment.period}}m</span>
                                        <span *ngIf="appointment?.appointment.status==='COMPLETED'" class="mx-1 text-success">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                fill="currentColor" class="bi bi-check-all" viewBox="0 0 16 16">
                                                <path
                                                    d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486z" />
                                            </svg>
                                        </span>
                                        <sub *ngIf="appointment?.appointment.status!='COMPLETED'">
                                            <small>{{appointment?.appointment.date | date: 'hh:mm'}} - {{appointment?.appointment.end_date | date: 'hh:mm'}}</small>
                                        </sub>
                                    </div>
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<ng-template #contentAppointment let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">New Appointment</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="mb-3 pb-3">
            <div class="row">
                <div class="col">
                    <label for="doctor_id" class="form-label">Patient</label>
                    <input type="text" class="form-control form-control-solid mb-3 mb-lg-0"
                        (keyup.enter)="onChangePatient($event)" (change)="onChangePatient($event)" list="auctionList"
                        id="auctionsList_id" placeholder="type patient's name ...">
                    <datalist id="auctionList">
                        <option *ngFor="let patient of patients" [value]="patient?.name">
                    </datalist>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col">
                    <label for="doctor_id" class="form-label">Recommended by</label>
                    <select class="form-select" [(ngModel)]="appointment.recommended_by">
                        <option [ngValue]="null">-- SELECT --</option>
                        <option *ngFor="let staff of staffs" [ngValue]='staff.id'>{{ staff.name }}
                        </option>
                    </select>
                </div>
                <div class="col">
                    <label for="doctor_id" class="form-label">Clinician</label>
                    <select class="form-select" [(ngModel)]="appointment.doctor_id">
                        <option [ngValue]="null">-- SELECT --</option>
                        <option *ngFor="let doctor of doctors" [ngValue]='doctor.id'>{{ doctor.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col">
                    <label for="date" class="form-label">Date & Time</label>
                    <input type="datetime-local" class="form-control" id="date" [(ngModel)]="appointment.date"
                        (ngModelChange)="refreshPeriodRange()"
                        [disabled]="appointment.doctor_id==null || appointment.recommended_by==null">
                </div>
            </div>
            <div class="row pt-3">
                <div class="col">
                    <label for="service" class="form-label">Type of Service</label>
                    <select class="form-select" [(ngModel)]="appointment.service_id" (change)="getPrice()"
                        [disabled]="appointment.patient_id==null">
                        <option [ngValue]="null">-- SELECT SERVICE --</option>
                        <option *ngFor="let service of services" [ngValue]='service.id'>{{ service.name }}
                        </option>
                    </select>
                </div>
                <div class="col">
                    <label for="price" class="form-label">Price</label>
                    <input type="number" class="form-control" [(ngModel)]="appointment.service_price" id="price"
                        disabled>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col">
                    <label for="service" class="form-label">Select Room</label>
                    <select class="form-select" [(ngModel)]="appointment.room"
                        [disabled]="appointment.patient_id==null">
                        <option [ngValue]="null">-- SELECT ROOM --</option>
                        <option value="room_001">Tratment Room 1</option>
                        <option value="room_002">Tratment Room 2</option>
                        <option value="room_003">Tratment Room 3</option>
                        <option value="room_004">Tratment Room 4</option>
                        <option value="adult_gym">Adults Gym</option>
                        <option value="swim_pool">Swimming Pool</option>
                        <option value="paeds_gym">Paeds Gym</option>
                        <option value="overbooked">Overbooked Room</option>
                        <option value="home_visit">Home visiting</option>
                        <option value="home_visit_ob">Home visiting (OB)</option>
                    </select>
                </div>
                <div class="col">
                    <label for="period" class="form-label">Appointment Period</label>
                    <div class="input-group">
                        <input type="number" class="form-control" id="period" min="1" step="1"
                            [(ngModel)]="appointment.period" name="period" placeholder="e.g. 25"
                            (input)="onPeriodInput($event)" (ngModelChange)="refreshPeriodRange($event)">
                        <span class="input-group-text">minutes</span>
                    </div>
                    @if (periodRangeLabel) {
                      <div class="form-text">{{ periodRangeLabel }}</div>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <span *ngIf="saving">Loading, Please wait ...</span>
        <button type="button" class="btn btn-success" (click)="createAppointment(contentPackage)"
            [disabled]="saving || !appointment.patient_id || !appointment.recommended_by || !appointment.doctor_id || !appointment.date || !appointment.service_id || !appointment.room || !appointment.period">Add</button>
    </div>
</ng-template>

<ng-template #contentPackage let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Select Package</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="mb-3 pb-3">
            <div class="row">
                <div class="col">
                    <p><b>Please Select Package type for payment if the payment is based on Installment, otherwise
                            select No Package.</b></p>
                </div>
            </div>
        </div>
        <div class="mb-3 pb-3">
            <div class="row">
                <div class="col">
                    <label for="gender" class="form-label">Package Type</label>
                    <select class="form-select" [(ngModel)]="appointment.package_id" (change)="onChangePackage()">
                        <option [ngValue]="null">-- No Package --</option>
                        <option *ngFor="let item of packages_list" [ngValue]='item.id'>{{ item.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label for="price" class="form-label">Number of Sessions</label>
                    <input type="text" class="form-control" [(ngModel)]="package.no_sessions" id="price" disabled>
                </div>
                <div class="col">
                    <label for="price" class="form-label">Package Price</label>
                    <input type="text" class="form-control" [(ngModel)]="package.full_price" id="price" disabled>
                </div>
                <div class="col">
                    <label for="price" class="form-label">Discounted Price</label>
                    <input type="number" class="form-control" [(ngModel)]="appointment.final_price" id="price">
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <span *ngIf="saving">Saving, Please wait ...</span>
        <button type="button" class="btn btn-success" (click)="createAppointment_with_package()"
            [disabled]="saving==true">Confirm</button>
    </div>
</ng-template>